module.exports = __webpack_public_path__ + "img/idea-validationIcon.a27f8d53.svg";